module.exports = __webpack_public_path__ + "static/media/tax-returns.7e3cb85a.png";